import { useQuery } from '@tanstack/react-query';
import { paymentApi } from '../api/payment.api';

/**
 * Hook to fetch payment sync status with automatic refresh
 * Polls every 30 seconds to keep the display up-to-date
 */
export function useSyncStatus() {
  return useQuery({
    queryKey: ['payment-sync-status'],
    queryFn: async () => {
      const response = await paymentApi.getSyncStatus();
      return response.data;
    },
    // Refetch every 30 seconds to keep relative time current
    refetchInterval: 30000,
    // Keep previous data while refetching
    placeholderData: (previousData) => previousData,
    // Always fetch fresh data on mount
    staleTime: 0,
  });
}
